import { Button, Form, message, Upload, Image, Space, Input, Divider } from "antd";
import React, { useState } from "react";
import { UploadOutlined } from '@ant-design/icons';
import { apiCall } from '../utils/Api';
import { useSession } from "../utils/Session";
import noimage from "../media/noimage.png"
import { ucfirst } from "../utils/Utils";
import CompanyCategories from "./CompanyCategories";
export default function BusinessDirectoryToggle(props) {

    const [session, setSession] = useSession();
    const [uploading, setUploading] = useState(false);
    const [cacheBuster, setCacheBuster] = useState(Date.now());

    const refresh = () => {
        apiCall("session/get", {}, (_s, _r) => {
            setSession(_r);
            setCacheBuster(Date.now());
        })
    }

    const uploadFile = ({ file, onSuccess, onError }, _type = "logo") => {
        setUploading(true);
        apiCall("account/uploadContactImage", { file: file, description: _type }, (_s, _r) => {
            if (_s) {
                message.success("Successfully uploaded.")
                onSuccess("Successfully uploaded.");
                refresh()
            } else {
                message.error(_r.error);
                onError(_r.error);
            }
        });
    }

    const removeImage = (_type) => {
        apiCall("account/deleteContactImage", { description: _type }, (_s, _r) => {
            if (_s) {
                refresh();
                message.success("Image removed.")
            } else {
                message.error(_r.error)
            }
        })
    }

    const drawUpload = (_type = "logo") => {

        return (
            <div>
                <div>{ucfirst(_type)} image</div>
                <div style={{ "padding": "10px", "border": "1px solid #eee" }}>
                    <Image
                        src={"https://bookmanager.com/tbm/?q=h.storeimg&id=" + session.user.corp_id + "&desc=" + _type + "&cb" + cacheBuster}
                        width={"100%"}
                        height={150}
                        fallback={noimage}
                        style={{
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ "alignItems": "center" }} className="float-flex">
                    <div style={{ "opacity": "0.6" }}><em>&nbsp;</em></div>
                    <div>
                        <div className="shim" /><div className="shim" />
                        <Space>
                            <Button onClick={() => removeImage(_type)} size="small" type="primary" danger><small>Remove</small></Button>
                            <Upload disabled={uploading} customRequest={(e) => uploadFile(e, _type)} showUploadList={false}>
                                <Button size="small" type="primary" icon={<UploadOutlined />}><small>&nbsp;Upload</small></Button>
                            </Upload>
                        </Space>
                    </div>
                </div>
            </div>)
    }

    return (
        <div>
            <em>
                <p>
                    Add your store to our business directory by filling out the fields below.
                    You can include up to 3 categories, a brief bio, a logo, and a store image.
                    <div className="shim" /><span style={{ "color": "red" }}>*</span><small> One category is required to submit your listing.</small>
                </p>
            </em>
            <Form.Item>
                <CompanyCategories form={props.form} />
                <div className="shim" /><div className="shim" /><div className="shim" />
                <div>Company Bio</div>
                <Form.Item initialValue={session?.user?.notes || ""} name="notes" >
                    <Input.TextArea placeholder="Company bio..." maxLength={2000} rows={6} showCount />
                </Form.Item>
                <div className="shim" />
                {drawUpload("store")}
                <div className="shim" />
                {drawUpload("logo")}

            </Form.Item>
        </div>
    )

}